import React from 'react';
import { Pill } from '@procore/core-react';
import { useStyles } from './TradePill.styles';

export function TradePill({ name }: { name: string }) {
  const classes = useStyles();
  return (
    <Pill className={classes.tradePill} key={name}>
      {name}
    </Pill>
  );
}
